module.exports = __webpack_public_path__ + "static/media/icon-piece6-1.54e24e92.png";